(function (global) {
  'use strict';
  function inspect(cart) {
    const groups = new Map();
    let hasPhysical = false;
    const invalid = [];
    for (const item of cart.items || []) {
      const fee = item.handle === 'premium-physical-gift-card';
      const physical = item.properties?.['Delivery format'] === 'Premium Physical Gift Card';
      const uid = item.properties?.['_Qi Gift UID'];
      if (!fee && !physical && !uid) continue;
      hasPhysical = true;
      if (!uid) { invalid.push(item.key); continue; }
      const lines = groups.get(uid) || [];
      lines.push(item); groups.set(uid, lines);
    }
    for (const lines of groups.values()) {
      const fees = lines.filter(item => item.handle === 'premium-physical-gift-card');
      const parents = lines.filter(item => item.handle !== 'premium-physical-gift-card');
      if (lines.length !== 2 || fees.length !== 1 || parents.length !== 1 ||
          parents[0].properties?.['Delivery format'] !== 'Premium Physical Gift Card' ||
          fees[0].quantity !== parents[0].quantity || parents[0].quantity < 1 ||
          String(fees[0].properties?.['_Voucher variant ID']) !== String(parents[0].variant_id)) {
        invalid.push(...lines.map(item => item.key));
      }
    }
    return { valid: invalid.length === 0, hasPhysical, invalidKeys: invalid };
  }
  global.QiGiftCartRules = { inspect };
  if (typeof module !== 'undefined') module.exports = { inspect };
  if (typeof document === 'undefined') return;
  let checking = false;
  const approved = new WeakSet();
  function showError(message) {
    document.querySelectorAll('[data-qi-cart-rule-error]').forEach(node => { node.textContent = message; node.hidden = false; });
    const existing = document.querySelector('[data-qi-cart-rule-error]');
    if (existing) existing.scrollIntoView?.({ block: 'nearest' });
    else window.location.assign((global.Shopify?.routes?.root || '/') + 'cart');
  }
  function syncAccelerated() {
    const physical = Boolean(document.querySelector('[data-qi-cart-physical="true"]'));
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(node => {
      node.hidden = physical;
      if (physical) node.style.setProperty('display', 'none', 'important');
      else node.style.removeProperty('display');
    });
  }
  async function check() {
    if (global.__qiGiftCartUpdating || global.__qiCartUpdating) {
      showError(global.qiGiftCartStrings?.busy || 'Your basket is updating. Please try again in a moment.'); return false;
    }
    try {
      const response = await fetch((global.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('basket');
      const result = inspect(await response.json());
      if (!result.valid) { showError(global.qiGiftCartStrings?.invalid || 'Please remove the incomplete physical gift card and add it again before checkout.'); return false; }
      return true;
    } catch (_) {
      showError(global.qiGiftCartStrings?.unavailable || 'We could not check your basket. Please try again.'); return false;
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (approved.has(form)) { approved.delete(form); return; }
    const submitter = event.submitter;
    const checkout = submitter?.name === 'checkout' || /\/checkout(?:[/?]|$)/.test(form.action || '') || (!submitter && form.querySelector?.('[name="checkout"]'));
    if (!checkout) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    global.__qiCartCheckoutChecking = true;
    try {
      if (await check()) {
        approved.add(form);
        form.requestSubmit(submitter || form.querySelector('[name="checkout"]') || undefined);
      }
    } finally { checking = false; global.__qiCartCheckoutChecking = false; }
  }, true);
  document.addEventListener('click', async event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || !/\/checkout(?:[/?]|$)/.test(anchor.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checking) return;
    checking = true;
    global.__qiCartCheckoutChecking = true;
    try { if (await check()) global.location.assign(anchor.href); }
    finally { checking = false; global.__qiCartCheckoutChecking = false; }
  }, true);
  document.addEventListener('DOMContentLoaded', syncAccelerated);
  new MutationObserver(syncAccelerated).observe(document.documentElement, { childList: true, subtree: true });
})(typeof window === 'undefined' ? globalThis : window);
